import React from "react";

import { useDojosSettings } from "./hooks/useDojosSettings";

import DojosHeader from "./components/DojosHeader";
import DojosKpiCards from "./components/DojosKpiCards";
import DojosFiltersCard from "./components/DojosFiltersCard";
import DojosTable from "./components/DojosTable";
import DojoFormDrawer from "./components/DojoFormDrawer";

export default function SettingsDojos() {
  const dashboard = useDojosSettings();

  return (
    <div className="space-y-5">
      <DojosHeader onCreate={dashboard.openCreateDrawer} />

      <DojosKpiCards
        stats={dashboard.stats}
        filteredStats={dashboard.filteredStats}
        loading={dashboard.loading}
      />

      <DojosFiltersCard
        filters={dashboard.filters}
        setFilter={dashboard.setFilter}
        resetFilters={dashboard.resetFilters}
        filteredCount={dashboard.filteredDojos.length}
        totalCount={dashboard.dojos.length}
        loading={dashboard.loading}
        onRefresh={dashboard.fetchDojos}
      />

      <DojosTable
        dojos={dashboard.filteredDojos}
        loading={dashboard.loading}
        deletingId={dashboard.deletingId}
        reordering={dashboard.reordering}
        onEdit={dashboard.openEditDrawer}
        onDelete={dashboard.handleDeleteDojo}
        onMoveUp={(dojo) => dashboard.moveDojo(dojo.id, "up")}
        onMoveDown={(dojo) => dashboard.moveDojo(dojo.id, "down")}
      />

      <DojoFormDrawer
        isOpen={dashboard.formDrawerOpen}
        mode={dashboard.formMode}
        dojo={dashboard.editableDojo}
        nextOrder={dashboard.nextOrder}
        submitting={dashboard.submittingForm}
        uploadProgress={dashboard.uploadProgress}
        onClose={dashboard.closeFormDrawer}
        onSubmit={dashboard.handleSubmitDojo}
      />
    </div>
  );
}